<template>

  <div>
    <b-row>
      <b-col class="col-12 text-center">
        <h1>รายการเอกสาร OCPB61/XXXXX ส่งกลับ/ส่งฝ่าย</h1>
      </b-col>

      <b-col class="mt-5 col-12  text-center">
        <h1 style="text-align:center;">
          ดำเนินการเรียบร้อยแล้ว
        </h1>
      </b-col>

      <b-col class="mt-5  col-12 text-center">
        <b-button
          variant="primary"
          @click="myRedirect()"
        >
          <span>กลับสู่หน้าหลัก</span>
        </b-button>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import { BRow, BCol, BButton } from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
  },
  methods: {

    myRedirect() {
      const routeData = this.$router.resolve({ name: 'LawLeaderDept' })
      window.open(routeData.href, '_self')
    },
  },
}
</script>

 <style lang="scss" >

</style>
